import Api from 'src/api/Base'

class DeleteChangeControlById extends Api {
  requestUrl = `/api/ChangeControl/${this.getParams().id}`

  method = 'DELETE'
}

export default DeleteChangeControlById
